import { 
  collection, 
  getDocs, 
  addDoc, 
  query, 
  where, 
  documentId,
  serverTimestamp,
  updateDoc,
  doc
} from "firebase/firestore";
import { db } from "../firebase";

// Dependencies işlemleri
export const getDependenciesByIds = async (ids) => {
  if (!ids || ids.length === 0) return [];
  
  try {
    // Firestore "in" sorgusu en fazla 10 eleman kabul eder.
    // Eğer 10'dan fazla dependency varsa parçalı sorgu yapılmalı.
    // Şimdilik basitçe 10 limiti varsayalım veya chunking yapalım.
    const chunks = [];
    for (let i = 0; i < ids.length; i += 10) {
      chunks.push(ids.slice(i, i + 10));
    }

    const promises = chunks.map(chunk => {
      const q = query(collection(db, "dependencies"), where(documentId(), "in", chunk));
      return getDocs(q);
    });

    const snapshots = await Promise.all(promises);
    const dependencies = [];

    snapshots.forEach(snapshot => {
      snapshot.forEach(doc => {
        dependencies.push({ id: doc.id, ...doc.data() });
      });
    });

    return dependencies;
  } catch (error) {
    console.error("Error fetching dependencies:", error);
    throw error;
  }
};

// Tracking Info işlemleri
export const saveTrackingInfo = async (trackingData) => {
  try {
    const docRef = await addDoc(collection(db, "trackingInfo"), {
      ...trackingData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return docRef.id;
  } catch (error) {
    console.error("Error saving tracking info:", error);
    throw error;
  }
};

export const updateTrackingInfo = async (id, trackingData) => {
  try {
    const docRef = doc(db, "trackingInfo", id);
    await updateDoc(docRef, {
      ...trackingData,
      updatedAt: serverTimestamp()
    });
  } catch (error) {
    console.error("Error updating tracking info:", error);
    throw error;
  }
};

export const getTrackingInfoByBillId = async (billId) => {
  try {
    const q = query(collection(db, "trackingInfo"), where("billId", "==", billId));
    const snapshot = await getDocs(q);
    
    if (!snapshot.empty) {
      const doc = snapshot.docs[0];
      return { id: doc.id, ...doc.data() };
    }
    return null;
  } catch (error) {
    console.error("Error fetching tracking info:", error);
    throw error;
  }
};

// Batch: birden çok billId için tek seferde tracking info çeker.
// Firestore "in" sorgusu max 10 eleman kabul ettiği için 10'lu chunk'lara böler.
// businessId: SaaS tenantRead() kuralının sorgu düzeyinde doğrulanabilmesi için zorunlu.
// Dönüş: { [billId]: trackingInfo } şeklinde bir map.
export const getTrackingInfoByBillIds = async (billIds, businessId) => {
  if (!billIds || billIds.length === 0) return {};

  try {
    const chunks = [];
    for (let i = 0; i < billIds.length; i += 10) {
      chunks.push(billIds.slice(i, i + 10));
    }

    const promises = chunks.map(chunk => {
      const constraints = [where("billId", "in", chunk)];
      if (businessId) constraints.push(where("businessId", "==", businessId));
      const q = query(collection(db, "trackingInfo"), ...constraints);
      return getDocs(q);
    });

    const snapshots = await Promise.all(promises);
    const trackingMap = {};

    snapshots.forEach(snapshot => {
      snapshot.forEach(doc => {
        const data = { id: doc.id, ...doc.data() };
        // getTrackingInfoByBillId ile aynı davranış: bir billId için ilk kayıt kazanır
        if (!trackingMap[data.billId]) {
          trackingMap[data.billId] = data;
        }
      });
    });

    return trackingMap;
  } catch {
    // best-effort; Firestore izni yoksa boş map döner
    return {};
  }
};
